import {StudentType} from './student-types';

export * from './student-types';
export * from './download-types';
export * from './contract-types';

export interface LecturerType {
	firstName: string;
	lastName: string;
	title: string;
}

export class Rectangle {
	width: number;
	height: number;

	constructor(width: number, height: number) {
		this.width = width;
		this.height = height;
	}
}

export interface UnitData {
	id: number;
	type: UnitType;
	name?: string;
}

export interface StudentWithUnit {
	studentId: number;
	unitData: UnitData,
}

export enum UnitType {
	Class,
	Group,
	None,
}

interface StudentWithUnitType extends StudentType {
	unitData: UnitData,
}

export interface UnitDataSettings {
	students: StudentWithUnitType[];
	lecturer: LecturerType;
}

export interface PrintSettings {
	wordsPerPage: number;
}

export type OptionItem = {
	label: string;
};

// export class Report {
// 	globalSchoolYearID: number;
// 	subjectID: number;
// 	subjectType: string;
// 	trackDates: TrackDatesModel[];
// 	gradeScaleEnabled: boolean;
// 	subjectGradeScales: SubjectGradeScale[];
// 	gradeScales: GradeScale[];
// 	students: Student[];
// 	showBaseline: boolean;
// 	showGradeColors: boolean;
// 	displayZeroIfNotTested: boolean;
// 	reportDisplayResultsMode: string;
// }

export class Student {
	firstName: string;
	lastName: string;
	subjects: Array<Subject>;
}

export class Subject {
	subjectID: number;
	tests: Array<Test>;
	name: string;
	gradeValues: Array<GradeValue>;
}
// export class TestModel {
// 	testID: number;
// 	subjectID: number;
// 	subjectType: string;
// 	subjectLevel: string;
// }
export class Test {
	testID: number;
	testName: string;
	questionCount: number;
	scores: Array<ScoreModel>;
	testSessions: Array<TestSessionModel>;
}

export class SubjectGradeScale {
	subjectID: number;
	gradeScaleID: number;
}

export class GradeScale {
	gradeScaleID: number;
	gradeValues: Array<GradeValue>;
}

export class GradeValue {
	name: string;
	description: string;
	color: string;
}

export class TrackDatesModel {
	from: string;
	to: string;
}

export class TestSessionModel {
	date: string;
	correctAnswers: number;
}

export class ScoreModel {
	score: number;
	percent: number;
	testDate?: string;
	grade: string;
	color: string;
}

export interface MarkingPeriod {
	title: string;
	index: number;
}